<template>
  <div>
    <!-- 退换货编辑 || 返件单号编辑：-->
    <el-dialog :title="type == 3
      ? $t('message.editTheReturnNumber')
      : $t('message.returnAndExchangeEditor')
      " :close-on-click-modal="false" :visible.sync="$parent.returnAndExchangeEditorDialogVisible" width="1432px"
      center>
      <div class="content">

        <!-- 类型 -->
        <div class="type" v-if="type == 1">
          <div class="refund_type">
            <!-- 退换货类别： -->
            <span>{{ $t("message.typeOfReturnOrExchange") }}:</span>
            <el-select v-model="itemData.refund_type" placeholder="请选择">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <!-- 批量操作-->
          <div class="all">
            <el-input v-model="all" placeholder="批量填写物流号" clearable></el-input>
            <!-- 新增 -->
            <el-button size="mini" type="success" @click="allAdd" style="margin-left: 10px;">{{
              $t("message.add")
            }}</el-button>
          </div>

        </div>
        <div class="type" v-else>
          <div></div>
          <!-- 批量操作-->
          <div class="all">
            <el-input v-model="all" placeholder="批量填写物流号" clearable></el-input>
            <!-- 新增 -->
            <el-button size="mini" type="success" @click="allAdd" style="margin-left: 10px;">{{
              $t("message.add")
            }}</el-button>
          </div>
        </div>
        <div class="table">
          <ol>
            <!--番号  -->
            <li class="flex05">{{ $t("message.mash") }}</li>
            <!--店铺信息  -->
            <li>{{ $t("message.shop") }}</li>
            <!--照片  -->
            <li>{{ $t("message.photo") }}</li>
            <!--交易号  -->
            <li>{{ $t("message.transactionNumber") }}</li>
            <!--商品属性  -->
            <li class="flex15">{{ $t("message.commodityAttribute") }}</li>
            <!--上架可能数  -->
            <li>{{ $t("message.possibleNumberOfShelves") }}</li>
            <!--退换货数量  -->
            <li>{{ $t("message.quantityOfReturnAndReplacement") }}</li>
            <!-- 物流号 || 返件单号-->
            <li class="flex3">
              {{
                type == 3
                  ? $t("message.returnNumber")
                  : $t("message.logisticsNumber")
              }}
            </li>
            <!-- 操作 -->
            <li>{{ $t("message.operation") }}</li>
          </ol>
          <ul v-for="(item, index) in itemData.order_purchase_refund_detail" :key="index">
            <!--编号  -->
            <li class="flex05">{{ item.order_purchase.order_detail.sorting }}</li>
            <!--店铺信息  -->
            <li>
              <div class="template">
                <p>{{ item.order_purchase.order_detail.shop_name }}</p>
                <p style="color: #15ad3c">
                  {{ item.order_purchase.order_detail.from_platform }}
                </p>
                <p>{{ item.order_purchase.order_detail.shop_id }}</p>
              </div>
            </li>
            <!--照片  -->
            <li>
              <el-popover placement="right" width="300" trigger="hover">
                <img :src="item.order_purchase.order_detail.pic" alt="" style="width: 300px; height: 300px" />
                <a href="JavaScript:;" slot="reference">
                  <el-image :src="item.order_purchase.order_detail.pic"
                    style="width: 60px; height: 60px; border-radius: 4px">
                    <div slot="placeholder" class="image-slot">
                      加载中<span class="dot">...</span>
                    </div>
                  </el-image>
                </a>
              </el-popover>
            </li>
            <!--交易号  -->

            <li>{{ item.order_purchase.purchase_no }}</li>
            <!--商品属性  -->
            <li class="flex15">
              <div class="attribute">
                <el-tooltip placement="bottom">
                  <div slot="content">
                    <div class="row" v-for="(itemDetail, itemIndex) in item.order_purchase
                      .order_detail.detail_y" :key="itemIndex" style="margin-bottom: 5px">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                  <div>
                    <div class="row" v-for="(itemDetail, itemIndex) in item.order_purchase
                      .order_detail.detail_y" :key="itemIndex">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                </el-tooltip>
              </div>
            </li>
            <!--上架可能数  -->
            <li>{{ item.order_purchase.possible_num }}</li>
            <!--退换货数量  -->
            <li>
              <el-input v-model="item.num" v-if="type == 1"></el-input>
              <span v-else>{{ item.num }}</span>
            </li>
            <!-- 物流号 -->
            <li class="flex3">
              <div class="template" v-if="type != 3">
                <!-- {{ item.order_purchase_refund_detail_return }} -->
                <div class="row" v-for="(items, indexs) in item.order_purchase_refund_detail_express" :key="indexs">
                  <el-input v-model="items.refund_express_no" :placeholder="$t('message.logisticsNumber')"></el-input>
                  <!-- 删除 -->
                  <el-button size="mini" type="primary" class="dark" @click="delItem(index, indexs)">{{
                    $t("message.delete") }}</el-button>
                </div>
                <!-- 新增 -->
                <el-button size="mini" type="success" @click="add(index)">{{
                  $t("message.add")
                }}</el-button>
              </div>
              <div class="template" v-else>
                <div class="row" v-for="(items, indexs) in item.order_purchase_refund_detail_return" :key="indexs">
                  <el-input v-model="items.return_express_no" :placeholder="$t('message.logisticsNumber')"></el-input>
                  <!-- 删除 -->
                  <el-button size="mini" type="primary" class="dark" @click="delItem(index, indexs)">{{
                    $t("message.delete") }}</el-button>
                </div>
                <!-- 新增 -->
                <el-button size="mini" type="success" @click="add(index)">{{
                  $t("message.add")
                }}</el-button>
              </div>
            </li>
            <!-- 操作 -->
            <li>
              <el-button type="primary" class="dark" @click="delList(index)">
                {{ $t("message.delete") }}
              </el-button>
            </li>
          </ul>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="$parent.returnAndExchangeEditorDialogVisible = false">{{ $t("message.cancel") }}</el-button>
        <!-- 修改 -->
        <el-button type="primary" @click="refundUpdate" v-if="type == 1">{{
          $t("message.ok")
        }}</el-button>
        <!-- 退货物流单号录入 -->
        <el-button type="primary" @click="expressUpdate" v-else-if="type == 2">{{ $t("message.ok") }}</el-button>
        <!-- 退货物流单号录入 -->
        <el-button type="primary" @click="setReturnExpress" v-else-if="type == 3">{{ $t("message.ok") }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    itemData: { type: Object },
    type: { type: Number }, //1编辑，2修改物流号，3返单输入
  },
  data() {
    return {
      val: "",
      all: '',
      options: [
        { label: "退货", value: 1 },
        { label: "换货", value: 2 },
      ],
    };
  },
  methods: {
    // 追加物流单号
    add(i) {
      if (this.type == 3) {
        this.itemData.order_purchase_refund_detail[
          i
        ].order_purchase_refund_detail_return.push({
          return_express_no: "",
        });
      } else {
        this.itemData.order_purchase_refund_detail[
          i
        ].order_purchase_refund_detail_express.push({
          refund_express_no: "",
        });
      }
    },
    // 删除物流单号
    delItem(index, indexs) {
      if (this.type == 3) {
        this.itemData.order_purchase_refund_detail[
          index
        ].order_purchase_refund_detail_return.splice(indexs, 1);
      } else {
        this.itemData.order_purchase_refund_detail[
          index
        ].order_purchase_refund_detail_express.splice(indexs, 1);
      }
    },
    // 退换货修改
    refundUpdate() {
      let data = {
        refund_sn: this.itemData.refund_sn,
        refund_type: this.itemData.refund_type,
        list: [],
      };
      let list = this.itemData.order_purchase_refund_detail;

      for (let i = 0; i < list.length; i++) {
        // if(list[i].num == '' || list[i].num == 0){
        //      this.$alert("退换货数量不能为0或者为空", "提示", {
        //     confirmButtonText: "确定",
        //     center: true,
        //   });
        // }

        let refund_express_no = [];
        list[i].order_purchase_refund_detail_express.forEach((item) => {
          refund_express_no.push(item.refund_express_no);

        });

        data.list.push({
          order_purchase_id: list[i].order_purchase_id,
          num: list[i].num,
          refund_express_no,
        });
      }
      this.$api.signInApi.refundUpdate(data).then((res) => {
        this.$message.success(res.msg);
        this.$parent.returnAndExchangeEditorDialogVisible = false;
        this.$parent.refundList();
      });
    },
    // 退货物流单号录入
    expressUpdate() {
      let data = {
        refund_sn: this.itemData.refund_sn,
        refund_type: this.itemData.refund_type,
        list: [],
      };
      let list = this.itemData.order_purchase_refund_detail;

      for (let i = 0; i < list.length; i++) {
        // if(list[i].num == '' || list[i].num == 0){
        //      this.$alert("退换货数量不能为0或者为空", "提示", {
        //     confirmButtonText: "确定",
        //     center: true,
        //   });
        // }
        let refund_express_no = [];
        list[i].order_purchase_refund_detail_express.forEach((item) => {
          data.list.push({
            refund_detail_id: list[i].id,
            refund_express_no: item.refund_express_no,
          });

        });

      }
      this.$api.signInApi.expressUpdate(data).then((res) => {
        this.$message.success(res.msg);
        this.$parent.returnAndExchangeEditorDialogVisible = false;
        this.$parent.refundList();
      });
    },
    // 设置返件单号
    setReturnExpress() {
      let data = {
        refund_sn: this.itemData.refund_sn,
        refund_type: this.itemData.refund_type,
        list: [],
      };
      let list = this.itemData.order_purchase_refund_detail;

      for (let i = 0; i < list.length; i++) {
        // if(list[i].num == '' || list[i].num == 0){
        //      this.$alert("退换货数量不能为0或者为空", "提示", {
        //     confirmButtonText: "确定",
        //     center: true,
        //   });
        // }
        let return_express_no = [];
        list[i].order_purchase_refund_detail_return.forEach((item) => {
          return_express_no.push(item.return_express_no);
        });
        console.log(list[i]);
        data.list.push({
          refund_detail_id: list[i].id,

          return_express_no,
        });
      }
      this.$api.signInApi.setReturnExpress(data).then((res) => {
        this.$message.success(res.msg);
        this.$parent.returnAndExchangeEditorDialogVisible = false;
        this.$parent.refundList();
      });
    },
    //删除列表
    delList(i) {
      this.itemData.order_purchase_refund_detail.splice(i, 1);
    },
    //批量新增
    allAdd() {
      if (this.all === '') return false
      if (this.type == 3) {
        this.itemData.order_purchase_refund_detail.forEach(item => {
          item.order_purchase_refund_detail_return.push({
            return_express_no: this.all,
          });
        })

      } else {
        this.itemData.order_purchase_refund_detail.forEach(item => {
          item.order_purchase_refund_detail_express.push({
            refund_express_no: this.all,
          });
        })

      }
      this.all = ''
    }
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0 15px;
  padding: 24px;
  background: #f8f8f8;
  border-radius: 8px;

  .type {
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;

    .all {
      display: flex;
    }

    span {
      margin-right: 20px;
    }
  }

  ul {
    padding: 24px 0;
  }

  li {
    margin-right: 24px;

    &:nth-last-child(1) {
      margin: 0;
    }
  }

  .flex15 {
    flex: 1.5;
  }

  .flex3 {
    flex: 3;

    .template {
      width: 100%;
    }

    .row {
      width: 100%;
      position: relative;
      margin-bottom: 10px;

      .el-button {
        position: absolute;
        top: 6px;
        right: 12px;
      }
    }
  }

  .flex05 {
    flex: 0.5;
  }
}
</style>